'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUserLoginFailedAction = exports.userLoginFailed = exports.isUserLoggedInAction = exports.userLoggedIn = exports.submitLoginForm = undefined;

var _authClientComponent = require('@wh/auth-client-component');

var _authClientComponent2 = _interopRequireDefault(_authClientComponent);

var _utils = require('./../utils/utils');

var _utils2 = _interopRequireDefault(_utils);

var _constants = require('./../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Submit login form
 * @param {Object} formData Data from the login form
 * @param {CasClient} casClient CAS client library
 * @returns {Object} The action to be dispatched
 */
var submitLoginForm = exports.submitLoginForm = function submitLoginForm(formData, casClient) {
  return {
    type: _constants.LOGIN_BUTTON_CLICKED,
    formData: formData,
    casClient: casClient
  };
};

/**
 * User loggedin successfully
 * @param {Object} casData Data returned by CAS: next and tempPassword
 * @returns {Object} The action to be dispatched
 */

var userLoggedIn = exports.userLoggedIn = function userLoggedIn(casData) {
  return {
    type: _constants.USER_LOGGED_IN,
    casData: casData
  };
};

/**
 * Checks if the passed action is of type USER_LOGGED_IN
 * @param {Object} action The action to be checked
 * @returns {Boolean} True if type is equal to USER_LOGGED_IN. False otherwise.
 */
var isUserLoggedInAction = exports.isUserLoggedInAction = (0, _utils2.default)(_constants.USER_LOGGED_IN);

/**
 * User failed to log in
 * @param {Object} error Error data
 * @returns {Object} The action to be dispatched
 */
var userLoginFailed = exports.userLoginFailed = function userLoginFailed(error) {
  return {
    type: _constants.USER_LOGIN_FAILED,
    error: error
  };
};

/**
 * Checks if the passed action is of type USER_LOGIN_FAILED
 * @param {Object} action The action to be checked
 * @returns {Boolean} True if type is equal to USER_LOGIN_FAILED. False otherwise.
 */
var isUserLoginFailedAction = exports.isUserLoginFailedAction = (0, _utils2.default)(_constants.USER_LOGIN_FAILED);
//# sourceMappingURL=actions.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/login-form/actions.js
// module id = 110
// module chunks = 0